import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '../src/assets/styles/global.css';
import router from './router';

// 在应用启动前确保页面在顶部
if (typeof window !== 'undefined') {
  window.scrollTo(0, 0);
}

import { createPinia } from "pinia";

const pinia = createPinia();

const app = createApp(App);
app.use(ElementPlus);
app.use(pinia);

app.use(router);

// 页面加载完成后确保滚动到顶部
window.addEventListener('load', () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
});

// DOMContentLoaded 事件处理
document.addEventListener('DOMContentLoaded', () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
});

app.mount('#app');
